<template>
	<div id="idFrmPan" ref="idFrmPan" style="display:flex; flex-direction:column; border:0px solid blue; height:100%;">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="flex: 0 0 auto; width:100%; height:50px; border:0px solid red;">
			<div class="SiftPanel" ref="idFindPan">
				<div class="NButton DIVNoSelect" style="width:70px; margin-top:-1px; margin-left:10px;" @click="onSceneAddClick">{{getLangText('新增')}}</div>

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('场景名称')}}</div>
				<input type="text" style="width:200px; margin-right:30px;" v-model="findSceneName">

				<!--radio style="height:30px; margin-right:20px;" v-model="findSceneMult" :size="18" :root="{obj:this}" :grpName="'GrpMult'" :val="1" :capt="getLangText('单人')" :checked="true" :myClick="showSex"></radio>
				<radio style="height:30px; margin-right:20px;" v-model="findSceneMult" :size="18" :root="{obj:this}" :grpName="'GrpMult'" :val="2" :capt="getLangText('多人')" :myClick="showSex"></radio-->

				<check style="height:30px; margin-right:10px; margin-left:10px;" :size="18" :grpName="'GrpRange'" :val="2" :capt="getLangText('私有')" :key="KeyPrivate" :checked="chkPrivate"></check>
				<check style="height:30px; margin-right:20px;"                   :size="18" :grpName="'GrpRange'" :val="1" :capt="getLangText('共享')" :key="KeyShare"   :checked="chkShare"></check>

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onSceneListClick"></div>

				<radio ref="idSex1" v-if="sexFlag" style="height:40px; margin-right:20px; margin-left:80px;" v-model="findSceneSex" :size="18" :root="{obj:this}" :grpName="'GrpSex'" :val="1" :capt="getLangText('男')" :myClick="onSexChange" :checked="true"></radio>
				<radio ref="idSex2" v-if="sexFlag" style="height:40px; margin-right:20px;"                   v-model="findSceneSex" :size="18" :root="{obj:this}" :grpName="'GrpSex'" :val="2" :capt="getLangText('女')" :myClick="onSexChange" ></radio>
			</div>
		</div>
		<div style="flex: 1 0 auto; width:100%; height:100%; border:0px solid blue;" id="idListPan" ref="idListPan">
			<div style="flex: 1 0 auto; width:100%; height:100%; border:0px solid blue; display:flex; flex-direction:row; flex-wrap:wrap; overflow-y:auto;" :key="KeyList">
				<div style="flex:0 0 auto; width:254px; height:316px; border:1px solid #bbbbbb; margin-left:70px; margin-top:40px; position:relative; z-index:900;" v-for="(curItem, index) in sceneData" :index="index">
					<div style="z-index:990; position:absolute; width:57px; height:57px; background:url(../static/images/publish3.png);" v-if="curItem.casCustId>0"></div>
					<div style="z-index:990; position:absolute; width:57px; height:57px; background:url(../static/images/publish2.png);" v-if="curItem.casCustId==0"></div>
					<div style="z-index:991; position:absolute; transform: rotate(-45deg) scale(0.7); left:-14px; top:10px; width:70px; height:20px; line-height:20px; border:0px solid red; color:#ffffff; text-align:center; font-size:14px;" class="DIVNoSelect">{{curItem.publicText}}</div>

					<ImgThumOP :item="curItem" :key="curItem.siId" :ty="'100'" style="z-index:992; position:absolute; width:28px; height:28px; left:220px;"></ImgThumOP>

					<div style="float:left; border:0px solid red; width:253px; height:28px; line-height:28px; text-align:center; border-bottom:1px solid #bbbbbb; font-size:14px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{curItem.casName}}</div>

					<div style="float:left; width:253px; height:253px; background:#bbbbbb; border:1px solid #bbbbbb;">
						<ImgThum :key="freshKey2+index" :item="curItem" :thW=244 :thH=244 style="float:left; border:0px solid red; width:100%; height:100%;"></ImgThum>
					</div>

					<div style="float:left; width:253px; height:36px; border-top:1px solid #bbbbbb; padding-top:3px;">
						<ImgThumOP :item="curItem" :ty="'9'" :dty="'cas'" :clk="onEditClick"     style="float:left;  margin-left: 6px;" ></ImgThumOP>
						<ImgThumOP :item="curItem" :ty="'4'" :dty="'cas'" :clk="onShareSetClick" style="float:left;  margin-left: 6px;" ></ImgThumOP>
						<ImgThumOP :item="curItem" :ty="'2'" :dty="'cas'" :clk="onSceneDelClick" style="float:right; margin-right:6px;" ></ImgThumOP>
					</div>
				</div>
			</div>
		</div>
		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>
	</div>
</template>

<script>

import ImgThum    from './ImgThum'
import ImgThumOP  from './ImgThumOP'
import cselect    from '../cf/cselect'
import check      from '../cf/cck'
import radio      from '../cf/cradio'
import popwin     from '../cf/popwin'
import popmenu    from '../cf/popmenu'
import cpage      from '../cf/cpage'

export default {
	name: 'aiScene',
	components:{
		ImgThumOP, ImgThum, cselect, check, popwin, popmenu, cpage, radio
	},
	data () {
		return {
			findSceneName: "",                   // 场景名称
			findMode: 1,                         // 单人-多人, 1-单人, 2-多人
			findSceneSex:  1,                    // 男女
			sexFlag: 1,                          // 是否显示性别选项

			KeyPrivate: 5000,
			KeyShare:   6000,
			chkPrivate: false,
			chkShare: false,

			ctrlWin:{                               // 弹出窗口控制属性
				w2: 964,
				h2: 600,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				vuepath: "/FrameBody/aiScene/SceneNew",
				rcallFunc: this.onSceneListClick,                 // 指定关闭弹出窗后需要执行的回调方法
			},

			frmW: 0,
			frmH: 0,
			freshKey2:  2000,
			keyFind:    3000,
			KeyList:    4000,
			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 10,                   //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[LangText('共'), LangText('条记录,'), LangText('页'), LangText('条/页'), LangText('页码'),'Go'],
				qryFunc: this.onSceneListClick,      //查询回调函数
			},
			sceneData:[],                           // 场景列表
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		this.frmW=this.$refs["idFrmPan"].clientWidth;
		this.frmH=this.$refs["idFrmPan"].clientHeight;
		this.$refs["idListPan"].style["height"] = (this.frmH-80)+"px";
		this.$refs["idListPan"].style["width"]  = (this.frmW)+"px";

		if( 0 <= (this.$route.query.findCustRange+"").indexOf("2") ) this.chkPrivate = true;
		if( 0 <= (this.$route.query.findCustRange+"").indexOf("1") ) this.chkShare = true;
		this.KeyPrivate++;
		this.KeyShare++;

		this.findMode = this.$route.query.mode;

		this.showSex();

		setTimeout( this.onSceneListClick, 50 );
	},
	watch:{

	},
	computed:{

	},
	methods:{
		onResize: function(){
			this.frmW=this.$refs["idFrmPan"].clientWidth;
			this.frmH=this.$refs["idFrmPan"].clientHeight;

			if( this.frmH > 0 ) this.$refs["idListPan"].style["height"] = (this.frmH-80)+"px";
			this.$refs["idListPan"].style["width"]  = (this.frmW)+"px";

			this.childResize( this );
		},
		showSex: function(){
			if( this.findMode==1 )   // 单人时, 显示男女选项
				 this.sexFlag = 1;
			else this.sexFlag = 0;
		},
		onSexChange: function(){
			for(let i=0; i<this.sceneData.length; i++ )
			{
				let item=this.sceneData[i];
				if( this.findSceneSex==1 )
					 item.path          = item.casImg1;
				else item.path          = item.casImg2;
			}
			this.freshKey2++;
			this.ctrlPage.total = this.sceneData.length;
			this.keyFind++;
			this.KeyList++;
		},
		onSceneAddClick: function(){
			this.ctrlWin.captCont = LangText("新增场景");
			this.ctrlWin.info={ mode:this.findMode, sex:this.findSceneSex, item:null };
			this.ctrlWin.self.onShow();
		},
		onSceneListClick: function(){
			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1, custId:this.login.custId, casName:this.findSceneName,
						casType:this.findMode };

			let v=this.getCheckValuesByName( "GrpRange");
			if( v=="1,2" || v=="2,1" )
				 body.custRange = 3;
			else body.custRange = parseInt(v)?parseInt(v):2;

			this.doTrade( "POST", ServAddr+"/api/custAiScene/list", this.onSceneListOK, true, body, null );
		},
		onSceneListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.sceneData = [];

			for(let i=0; i<data.body.custAiSceneList.length; i++ )
			{
				let item=data.body.custAiSceneList[i];

				let img={};

				if( this.findMode == 1 )   // 单人
				{
					img.casImg1 = item.casImg1;
					img.casImg2 = item.casImg2;

					if( this.findSceneSex==1 )
						 img.path = item.casImg1;
					else img.path = item.casImg2;
				}
				else   // 多人场景
				{
					img.casImg1 = item.casImg1;
					img.path    = item.casImg1;
				}

				img.casCustId     = item.casCustId;
				img.casId         = item.casId;
				img.casType       = item.casType;
				img.casName       = item.casName;
				img.casPrompt     = item.casPrompt;
				img.width         = 1024;
				img.height        = 1024;

				if( img.casCustId == 0 )
					 img.publicText = LangText("共享");
				else img.publicText = LangText("私有");

				this.sceneData.push( img );
			}

			this.freshKey2++;
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;
			this.KeyList++;
		},
		onSceneDelClick: function( event, item ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("警告"), LangText("确定要删除吗?"), "", {okFunc:this.doSceneDel, okParam:item} );
		},
		doSceneDel: function( item ){
			this.doTrade( "DELETE", ServAddr+"/api/custAiScene/aiSceneDel/"+item.casId, this.onSceneListClick, true, null, null );
		},
		onShareSetClick: function( e, item ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("提示"), LangText("确定要共享吗?"), "", {okFunc:this.doSceneShare, okParam:item} );
		},
		doSceneShare: function( param ){
			this.doTrade( "PUT", ServAddr+"/api/custAiScene/shareSet/"+param.casId, this.onSceneListClick, true, null, null );
		},
		onEditClick: function( e, item ){
			this.ctrlWin.captCont = LangText("修改场景");
			this.ctrlWin.info={ mode:this.findMode, sex:this.findSceneSex, item:item };
			this.ctrlWin.self.onShow();
		},
	}
}

</script>

<style scoped>

.OP1Icon{ float:left; width:26px; height:26px; border:1px solid #47c2d0; cursor:pointer; }
.OP1Icon:hover{ opacity:0.7; }

.OP2Icon{ float:left; width:26px; height:26px; border:1px solid #c4c4c4; }

</style>



// WEBPACK FOOTER //
// aiScene.vue?03f6fd7a